var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFormsFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.275 6.975L14.025 1.725C13.875 1.575 13.725 1.5 13.5 1.5H6C5.175 1.5 4.5 2.175 4.5 3V21C4.5 21.825 5.175 22.5 6 22.5H18C18.825 22.5 19.5 21.825 19.5 21V7.5C19.5 7.275 19.425 7.125 19.275 6.975ZM13.5 3.3L17.7 7.5H13.5V3.3ZM18 21H6V3H12V7.5C12 8.325 12.675 9 13.5 9H18V21Z",
    fill: "#0a60a1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59961 21.6004V2.40039H11.1996C11.5196 2.40039 12.1329 2.66706 12.3996 2.80039C12.3996 3.20039 13 2.48039 13 2.80039C13 3.20039 14.3996 6.80039 14.7996 7.20039C15.1196 7.52039 17.3329 7.60039 18.3996 7.60039V8.80039V21.6004H5.59961Z",
    fill: "#0a60a1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 16.5H16.5V18H7.5V16.5ZM7.5 12H16.5V13.5H7.5V12Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1992 7.5998V2.7998L17.9992 7.5998H13.1992Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormsFilled);
export default __webpack_public_path__ + "static/media/forms-filled.090c96999edb2eed88f65771a5c94a3c.svg";
export { ForwardRef as ReactComponent };